<script>
  import * as restfulService from '../../../services/restfulService'

  import bus from '@utils/bus'
  import { mapActions } from 'vuex'

  import { required, minLength } from 'vuelidate/lib/validators'
  import swal from 'sweetalert2'
  import moment from 'moment'

  export default {
    data () {
      return {
        turno: 'manha',
        botaoClicado: false,
        hashValido: false,
        hash: '',
        matricula: '',
        novaSenha: '',
        novaSenhaConfirmacao: ''
      }
    },
    validations: {
      hash: { required },
      matricula: { required },
      novaSenha: { required, minLength: minLength(6) },
      novaSenhaConfirmacao: { required }
    },
    beforeMount () {
      let horaAtual = moment().format('HH:mm')
      if (horaAtual >= '07:00' && horaAtual <= '18:00') {
        this.turno = 'manha'
      } else {
        this.turno = 'noite'
      }
    },
    mounted () {
      let hash = this.$route.params.hash
      if (!hash) {
        swal({
          title: 'Atenção',
          html: 'A chave de validação não foi encontrada',
          type: 'warning'
        })
        setTimeout(() => {
          bus.$emit('hide-loader')
        }, 500)
      } else {
        this.verificarHash(hash)
      }
    },
    computed: {
      senhaNovaSenhaErros () {
        const erros = []
        if (!this.$v.novaSenha.$dirty) return erros
        !this.$v.novaSenha.required && erros.push('O campo Senha é obrigatório')
        !this.$v.novaSenha.minLength && erros.push('A senha precisa ter no mínimo 6 caracteres')
        return erros
      },
      senhaNovaSenhaConfirmacaoErros () {
        const erros = []
        if (!this.$v.novaSenhaConfirmacao.$dirty) return erros
        !this.$v.novaSenhaConfirmacao.required && erros.push('O campo Confirmação de Senha é obrigatório')
        if (this.senhasDiferentes) {
          erros.push('As senhas precisam ser iguais')
        }
        return erros
      },
      senhasDiferentes () {
        return this.novaSenha !== this.novaSenhaConfirmacao
      }
    },
    methods: {
      ...mapActions(['showNotification']),
      verificarHash (hash) {
        let data = { hash }
        restfulService.post('acesso', 'checar-hash', null, data)
          .then(response => {
            bus.$emit('hide-loader')
            if (response.hasOwnProperty('message')) {
              swal({
                title: 'Atenção',
                html: 'A chave de validação não foi encontrada',
                type: 'warning'
              })
            } else {
              this.hashValido = true
              this.$refs.matricula.focus()
              this.hash = hash
            }
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.hashValido = false
            this.botaoClicado = false
            console.log(e)
          })
      },
      recuperarSenha () {
        let data = {
          hash: this.hash,
          matricula: this.matricula,
          senha: this.novaSenha,
          confirmacao_senha: this.novaSenhaConfirmacao
        }
        restfulService.post('acesso', 'recuperar-senha', null, data)
          .then(response => {
            this.botaoClicado = false
            this.showNotification({ message: 'Sua senha foi alterada' })
            this.$router.push({ name: 'login' })
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.botaoClicado = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="login-box" v-bind:class="{'-day': turno === 'manha', '-night': turno === 'noite'}">

        <div class="overlay"></div>

        <div class="login-content">
            <div>
                <div class="login-header">
                    <h2 class="login-header-title">SOU</h2>
                    <figure class="logo">
                        <img src="https://urcamp.edu.br/site/img/logos/logo-branco.png" alt="">
                    </figure>
                </div>

                <form class="login-form" v-on:submit.prevent>
                    <h4 class="recuperacao-titulo">Recuperação de senha</h4>
                    <div class="login-form-item">
                        <div class="icon">
                            <i class="fas fa-user"></i>
                        </div>
                        <input type="tel"
                               v-model="matricula"
                               ref="matricula"
                               @keyup.enter.native="recuperarSenha"
                               placeholder="Matrícula">
                    </div>
                    <div class="login-form-item">
                        <div class="icon">
                            <i class="fas fa-lock"></i>
                        </div>
                        <input type="password"
                               v-model="novaSenha"
                               ref="novaSenha"
                               @input="$v.novaSenha.$touch()"
                               @blur="$v.novaSenha.$touch()"
                               @keyup.enter.native="recuperarSenha"
                               placeholder="Nova Senha">
                    </div>
                    <div class="login-form-item">
                        <div class="icon">
                            <i class="fas fa-lock"></i>
                        </div>
                        <input type="password"
                               v-model="novaSenhaConfirmacao"
                               ref="novaSenhaConfirmacao"
                               @input="$v.novaSenhaConfirmacao.$touch()"
                               @blur="$v.novaSenhaConfirmacao.$touch()"
                               @keyup.enter.native="recuperarSenha"
                               placeholder="Confirmação de Senha">
                    </div>
                    <v-alert :value="senhaNovaSenhaErros.length || senhaNovaSenhaConfirmacaoErros.length"
                             class="erros-validacao"
                             color="error"
                             icon="warning">
                        <div v-for="item in senhaNovaSenhaErros">{{item}}</div>
                        <div v-for="item in senhaNovaSenhaConfirmacaoErros">{{item}}</div>
                    </v-alert>
                    <button type="submit"
                            @click="recuperarSenha"
                            :disabled="botaoClicado || $v.$invalid || !hashValido || senhasDiferentes"
                            class="login-submit">
                        Alterar Senha
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .recuperacao-titulo {
        text-align: center;
        color: rgba(255, 255, 255, .8);
        font-size: 28px;
        font-weight: 400;
        padding: 0 0 25px;
    }

    .erros-validacao {
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// RecuperarSenha.vue?6303cdca